import { useNavigate } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import AppButton from '../components/common/AppButton';
import { useAuth } from '../context/AuthContext';

const HomePage: React.FC = () => {
  const { logout, company, hasPermission } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <AuthLayout
      title="Site Under Construction"
      subtitle="We're making improvements and will be back soon."
    >
      <div className="flex flex-col gap-4 items-center text-center">
        <p>Please use the Pool Guy mobile app for now.</p>
        <p className="text-sm">Thank you for your patience.</p>

        <div className="w-full px-8 mt-4 flex flex-col gap-6">
          {hasPermission('canManageSubscription') &&
            company?.subscription?.store === 'stripe' && (
              <AppButton
                fullWidth
                onClick={() => navigate('/subscription/manage')}
              >
                Manage subscription
              </AppButton>
            )}
          <AppButton fullWidth variant="secondary" onClick={handleLogout}>
            Log out
          </AppButton>
        </div>
      </div>
    </AuthLayout>
  );
};

export default HomePage;
